<template>
  <v-form ref="solicitacao" lazy-validation @submit.prevent="onSubmit()">
    <v-container fluid>
      <v-row>
        <v-col
          :md="12"
          :sm="12"
          :xs="12"
          cols="12"
          style="padding-bottom: 35px;"
        >
          <v-autocomplete
            v-model="solicitacao.agenteRegulado"
            :loading="isLoadingAgentesRegulados"
            :items="agentesRegulados"
            :search-input.sync="searchAgentesRegulados"
            :item-text="'nome'"
            :item-value="selectAgenteRegulado"
            :rules="[rules.required]"
            cache-items
            hide-no-data
            hide-details
            label="Empresa/Orgão/Cooperativa *"
            placeholder="Selecione uma empresa"
            filled
            rounded
            dense
          ></v-autocomplete>
        </v-col>
        <template v-if="solicitacao.area && solicitacao.area.id !== 3">
          <v-col :md="7" :sm="7" :xs="12" cols="12" class="pt-0 pb-3">
            <v-text-field
              v-model="solicitacao.unidadeConsumidoraNumero"
              placeholder="Digite o número da unidade consumidora"
              label="Unidade Consumidora *"
              :rules="[rules.required]"
              v-mask="'#############'"
              filled
              rounded
              dense
            ></v-text-field>
          </v-col>
          <v-col :md="5" :sm="5" :xs="12" cols="12" class="pt-0 pb-0">
            <v-switch
              v-model="solicitacao.entrouEmContato"
              label="Entrou em contato?"
            ></v-switch>
          </v-col>
        </template>
        <template v-if="solicitacao.area && solicitacao.area.id === 3">
          <v-col :md="12" :sm="12" :xs="12" cols="12" class="pt-0 pb-3">
            <v-text-field
              v-model="solicitacao.viagemHoraDeInicio"
              placeholder="Ex: 06:10"
              label="Horário Início da Viagem *"
              :rules="[rules.required]"
              filled
              v-mask="'##:##'"
              rounded
              dense
            ></v-text-field>
          </v-col>
          <v-col :md="12" :sm="12" :xs="12" cols="12" class="pt-0 pb-3">
            <v-text-field
              v-model="solicitacao.viagemLocalDeInicio"
              placeholder="Digite o local do início da viagem"
              label="Local Início da Viagem *"
              :rules="[rules.required]"
              filled
              rounded
              dense
            ></v-text-field>
          </v-col>
          <v-col :md="12" :sm="12" :xs="12" cols="12" class="pt-0 pb-3">
            <v-text-field
              v-model="solicitacao.viagemLocalDeFim"
              placeholder="Digite o local do fim da viagem"
              label="Local Fim da Viagem *"
              :rules="[rules.required]"
              filled
              rounded
              dense
            ></v-text-field>
          </v-col>
          <v-col :md="12" :sm="12" :xs="12" cols="12" class="pt-0 pb-3">
            <v-text-field
              v-model="solicitacao.viagemNomeDaLinha"
              placeholder="Digite o nome da linha "
              label="Número da Linha *"
              filled
              rounded
              dense
              :rules="[rules.required]"
            ></v-text-field>
          </v-col>
        </template>
        <v-col :md="12" :sm="12" :xs="12" cols="12" class="pt-0 pb-3">
          <v-textarea
            v-model="solicitacao.mensagem"
            placeholder="Digite o que aconteceu"
            label="Mensagem *"
            :rules="[rules.required]"
            filled
            rounded
            dense
          ></v-textarea>
        </v-col>
        <v-col :md="12" :sm="12" :xs="12" cols="12" class="pt-0 pb-3">
          <v-textarea
            v-model="solicitacao.pretensao"
            placeholder="Resultado esperado"
            label="Resultado Esperado (Pretensão) *"
            :rules="[rules.required]"
            filled
            rounded
            dense
          ></v-textarea>
        </v-col>
        <v-col :md="12" :sm="12" :xs="12" cols="12" class="pt-0 pb-0">
          <vue-recaptcha
            ref="recaptcha"
            :sitekey="siteKey"
            :loadRecaptchaScript="true"
            @verify="verifyRecaptcha"
            @expired="expiredRecaptcha"
          ></vue-recaptcha>
          <v-input
            v-model="solicitacao.recaptcha"
            :rules="[rules.required]"
            class="pt-0 pb-0"
            style="margin-top: -10px;"
          ></v-input>
        </v-col>
        <v-col :md="2" class="pt-3 pb-0">
          <v-btn
            outlined
            block
            large
            color="primary"
            type="button"
            :width="100"
            @click="backStepper()"
          >
            <v-icon>keyboard_arrow_left</v-icon>Voltar
          </v-btn>
        </v-col>
        <v-col :md="2" :offset-md="8" class="pt-3 pb-0">
          <v-btn depressed block large color="primary" type="submit"
            >Enviar</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import { mask } from "vue-the-mask";
import SolicitacaoModule from "@/store/modules/solicitacao";
import SolicitacaoService from "@/services/solicitacao.service";
import GlobalStore from "@/store/modules/global";
import { delay } from "rxjs/operators";

import VueRecaptcha from "vue-recaptcha";
import { VUE_APP_RECAPTCHA_KEY } from "@/commons/config";

import { mapState } from "vuex";

import AgenteReguladoService from "@/services/agente_regulado.service";

export default {
  components: {
    VueRecaptcha
  },
  directives: {
    mask
  },
  data() {
    return {
      siteKey: VUE_APP_RECAPTCHA_KEY,
      rules: {
        required: value =>  !!value || "Esse campo deve ser preenchido",
      },
      //solicitacao: SolicitacaoModule.solicitacao,
      // form: {
      //   unidadeConsumidoraNumero: null,
      //   entrouEmContato: null,
      //   agenteRegulado: null,
      //   horarioPartidaTransporte: null,
      //   localpartida: null,
      //   localChegada: null,
      //   nomeLinhaTransporte: null,
      //   mensagem: null,
      //   pretensao: null,
      //   recaptcha: null
      // },
      agentesRegulados: [],
      isLoadingAgentesRegulados: false,
      searchAgentesRegulados: null
    };
  },
  methods: {
    selectAgenteRegulado(event) {
      return { id: event.id, nome: event.nome };
    },
    backStepper() {
      SolicitacaoModule.setCurrentStep(2);
      this.$vuetify.goTo(0);
    },
    verifyRecaptcha(value) {
      this.solicitacao.recaptcha = value;
    },
    expiredRecaptcha() {
      this.$refs.recaptcha.reset();
      this.solicitacao.recaptcha = null;
    },
    onSubmit() {
      const isValid = this.$refs.solicitacao.validate();
      if (isValid) {
        SolicitacaoModule.setIsLoading(true);
        SolicitacaoModule.setstepperThreeValid(isValid);
        //const solicitacao = Object.assign(this.form, this.solicitacao);

        SolicitacaoService.create(this.solicitacao)
          .pipe(delay(1000))
          .subscribe(
            res => {
              const { id } = res;
              SolicitacaoModule.setIsLoading(false);
              SolicitacaoModule.setSendedSolicitation(true);
              SolicitacaoModule.setCodigoSolicitation(id);
              this.$vuetify.goTo(0);
            },
            error => {
              SolicitacaoModule.setIsLoading(false);
            }
          );
      }
    },
    loadAgentesRegulados() {
      AgenteReguladoService.getAll().subscribe(
        res => {
          this.agentesRegulados = res;
        },
        error => {
          //console.log("Agentes Regulados Erro ", res);
        }
      );
    }
  },
  mounted() {
    this.loadAgentesRegulados();
  },
  computed: {
    solicitacao: {
      get: () => SolicitacaoModule.solicitacao
    }
  }
};
</script>
